import {io} from "socket.io-client"

const socket = (token) => new io(process.env.REACT_APP_API_URL, {
    autoConnect: false,
    withCredentials: true,
    auth: {
        token: token
    }
})

export default socket;